/* v3.0: sticky Add to cart bar on phones */
(function () {
  var bar = document.querySelector('[data-sticky-buy]');
  if (!bar) return;
  var root = bar.closest('[data-product-section], section') || document;
  var form = root.querySelector('[data-product-form]') || document.querySelector('[data-product-form]');
  if (!form) return;
  var mainBtn = form.querySelector('[data-add]');
  var anchor = form.querySelector('.buy') || mainBtn;
  var stickyBtn = bar.querySelector('[data-sticky-add]');
  var priceOut = bar.querySelector('[data-sticky-price]');
  var priceIn = root.querySelector('[data-price]') || document.querySelector('[data-price]');
  var docEl = document.documentElement;
  var shown = false;
  document.body.appendChild(bar);

  function syncState() {
    if (priceIn && priceOut) {
      var p = priceIn.querySelector('.price__sale') || priceIn.querySelector('span:not(.visually-hidden)');
      if (p) priceOut.textContent = p.textContent.replace(/^\s*From\s+/i, '').trim();
    }
    if (mainBtn && stickyBtn) {
      stickyBtn.disabled = mainBtn.disabled;
      stickyBtn.textContent = mainBtn.textContent.trim() || mainBtn.getAttribute('data-add-label') || 'Add to cart';
    }
  }

  function setShown(v) {
    if (v === shown) return;
    shown = v;
    if (v) syncState();
    bar.classList.toggle('is-visible', v);
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    stickyBtn.tabIndex = v ? 0 : -1;
    docEl.classList.toggle('has-sticky-buy', v);
  }

  if ('IntersectionObserver' in window && anchor) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  stickyBtn.addEventListener('click', function () {
    if (!mainBtn || mainBtn.disabled) return;
    mainBtn.click();
  });

  if (priceIn && 'MutationObserver' in window) {
    new MutationObserver(function () { if (shown) syncState(); }).observe(priceIn, { childList: true, subtree: true, characterData: true });
  }
  if (mainBtn && 'MutationObserver' in window) {
    new MutationObserver(syncState).observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }
  form.addEventListener('change', function () { setTimeout(syncState, 60); });
})();

/* v3.1: Why Shop — light follows the pointer across the panel and cards */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.why-section--charcoal .why-panel').forEach(function (panel) {
    var cards = panel.querySelectorAll('.why__feature, .why__item');
    var raf = 0, ev = null;
    function paint() {
      raf = 0;
      var r = panel.getBoundingClientRect();
      panel.style.setProperty('--px', (ev.clientX - r.left) + 'px');
      panel.style.setProperty('--py', (ev.clientY - r.top) + 'px');
      cards.forEach(function (c) {
        var cr = c.getBoundingClientRect();
        c.style.setProperty('--mx', (ev.clientX - cr.left) + 'px');
        c.style.setProperty('--my', (ev.clientY - cr.top) + 'px');
      });
    }
    panel.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
  });
})();
